import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { importFileReducer } from "./importReducer";
import { userModulesReducer, userSitesReducer } from "./userRightReducer";

import {
  folderListReducer,
  fileListReducer,
  folderNavReducer,
  folderSelectReducer,
  propertySeqReducer,
  primaryPropertyFileSeqReducer,
  propertyDetailReducer,
  propertyFileReducer,
  uploadFileSourceReducer,
  uploadFilePropertyReducer,
  advancedSearchReducer,
  companyListByFolderReducer,
  selectedFolderReducer,
} from "./fileManagerReducer";

import { pilDetailsReducer } from "./pilReducer";

import {
  docSubSearchPropertyReducer,
  selectedSubmissionSeqReducer,
  submissionDetailReducer,
  modifySubmissionValueReducer,
  documentSubmissionTypeReducer,
  documentSubmissionFormFieldReducer,
  documentSubmissionCreateValueReducer,
} from "./documentSubmissionReducer";

import {
  circulationListReducer,
  circulationDetailReducer,
  userListReducer,
  userGroupListReducer,
  userChosenReducer,
  circulationDataReducer,
} from "./circulationReducer";

import {
  tabmenuChangeReducer,
  latestDrawingReducer,
  drawingPropertyReducer,
  fileUploadingPropertyReducer,
  unpublishPacksReducer,
  unpublishDetailReducer,
  relatedItemPropertyReducer,
} from "./drawingRegisterReducer";

import {
  submissionRFIDetailReducer,
  rfiListReducer,
  submissionRFIResponseReducer,
  submissionRFICommentReducer,
} from "./rfiReducer";

import {
  submissionTransmittalDetailReducer,
  submissionTransmittalCommentReducer,
  submissionTransmittalSoftCopyDetailReducer,
} from "./transmittalReducer";

const rootReducer = combineReducers({
  // User Right
  userModulesRedux: userModulesReducer,
  userSitesRedux: userSitesReducer,

  // File Manager
  authList: authReducer,
  folderList: folderListReducer,
  fileList: fileListReducer,
  folderNav: folderNavReducer,
  propertySeqRedux: propertySeqReducer,
  primaryPropertyFileSeqRedux: primaryPropertyFileSeqReducer,
  propertyDetail: propertyDetailReducer,
  folderSelectedRedux: folderSelectReducer,
  propertyFileRedux: propertyFileReducer,
  uploadFileSourceRedux: uploadFileSourceReducer,
  uploadFilePropertyRedux: uploadFilePropertyReducer,
  advancedSearchRedux: advancedSearchReducer,
  companyListByFolderRedux: companyListByFolderReducer,
  selectedFolderRedux: selectedFolderReducer,

  // Document Submission
  docSubSearchPropertyRedux: docSubSearchPropertyReducer,
  selectedSubmissionSeqRedux: selectedSubmissionSeqReducer,
  submissionDetailRedux: submissionDetailReducer,
  modifySubmissionValueRedux: modifySubmissionValueReducer,
  documentSubmissionTypeRedux: documentSubmissionTypeReducer,
  documentSubmissionFormFieldRedux: documentSubmissionFormFieldReducer,
  documentSubmissionCreateValueRedux: documentSubmissionCreateValueReducer,

  // Circulation
  circulationListRedux: circulationListReducer,
  circulationDetailRedux: circulationDetailReducer,
  userListRedux: userListReducer,
  userGroupListRedux: userGroupListReducer,
  userChosenRedux: userChosenReducer,
  circulationDataRedux: circulationDataReducer,

  // Drawing Register
  tabmenuChangeRedux: tabmenuChangeReducer,
  latestDrawingRedux: latestDrawingReducer,
  drawingPropertyRedux: drawingPropertyReducer,
  fileUploadingPropertyRedux: fileUploadingPropertyReducer,
  unpublishPacksRedux: unpublishPacksReducer,
  unpublishDetailRedux: unpublishDetailReducer,
  relatedItemPropertyRedux: relatedItemPropertyReducer,

  //rfi
  rfiList: rfiListReducer,
  submissionRFIDetailRedux: submissionRFIDetailReducer,
  submissionRFIResponseRedux: submissionRFIResponseReducer,
  submissionRFICommentRedux: submissionRFICommentReducer,

  //transmittal
  submissionTransmittalDetailRedux: submissionTransmittalDetailReducer,
  submissionTransmittalCommentRedux: submissionTransmittalCommentReducer,
  submissionTransmittalSoftCopyDetailRedux:
    submissionTransmittalSoftCopyDetailReducer,

  //import file
  importFileRedux: importFileReducer,

  pilDetailsRedux: pilDetailsReducer,
});

export default rootReducer;
